import React from "react";
import { Box, FormControl, FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";

interface SOIProps {
  selectedOption: number,
  setOption: (e: number) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hidden: {
      visibility: "hidden",
      "-webkit-appearance": "none",
      "-moz-appearance": "none",
      "-ms-appearance": "none",
      "-o-appearance": "none",
      appearance: "none"
    },
    formControl: {
      margin: 0
    },
    selectedFormControl: {
      background: "lightgray",
      margin: 0
    }
  }),
);

export default function RadioButtonsGroup(props: SOIProps) {
  const { t } = useTranslation();
  const classes = useStyles();


  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.setOption(+event.target.value);
  };

  return (
    <FormControl component="fieldset" style={{ textAlign: 'left', width: "100%" }}>
      <RadioGroup
        aria-label="gender"
        name="gender1"
        value={props.selectedOption}
        onChange={handleChange}
      >
        <FormControlLabel
          className={props.selectedOption === 0 ? classes.selectedFormControl : classes.formControl}
          value={0}
          control={<Radio className={classes.hidden} />}
          label={props.selectedOption === 0 ?
            <Box fontWeight="fontWeightBold">{t('operationHours.baseAdjustment')}</Box> :
            t('operationHours.baseAdjustment')
          }
        />
        <FormControlLabel
          className={props.selectedOption === 1 ? classes.selectedFormControl : classes.formControl}
          value={1}
          control={<Radio className={classes.hidden} />}
          label={props.selectedOption === 1 ?
            <Box fontWeight="fontWeightBold">{t('operationHours.rangeDaysAdjustment')}</Box> :
            t('operationHours.rangeDaysAdjustment')
          }
        />
        <FormControlLabel
          className={props.selectedOption === 2 ? classes.selectedFormControl : classes.formControl}
          value={2}
          control={<Radio className={classes.hidden} />}
          label={props.selectedOption === 2 ?
            <Box fontWeight="fontWeightBold">{t('operationHours.singleDayAdjustment')}</Box> :
            t('operationHours.singleDayAdjustment')
          }
        />
      </RadioGroup>
    </FormControl>
  );
}
